module.exports = __webpack_public_path__ + "media/application/images/icas-small-155f1b5d1e5294b206e655ef2f7651ea.png";